(function () {
  if (typeof document === 'undefined') return;
  var roots = Array.prototype.slice.call(document.querySelectorAll('.main-tag-tabs'));
  if (!roots.length) return;

  roots.forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.main-tag-tabs__btn'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.main-tag-tabs__panel'));
    if (!buttons.length || !panels.length) return;

    function activate(name) {
      buttons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-tab') === name;
        btn.classList.toggle('is-active', isActive);
      });
      panels.forEach(function (panel) {
        var show = panel.getAttribute('data-panel') === name;
        if (show) {
          panel.classList.remove('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var name = btn.getAttribute('data-tab');
        activate(name);
      });
    });

    // Default to first button's tab if present, else 'learn'
    var initial = buttons[0] ? buttons[0].getAttribute('data-tab') : 'learn';
    activate(initial);
  });
})();
